// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  background: #f6f1ef;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.wrapper-modal .header-block {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper-modal .header-block .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .header-block .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper-modal .header-block .close-icon:hover {
  background: #f2dbd9;
}

.title {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  font-size: 15px;
  letter-spacing: 0.08em;
  margin-bottom: 10px;
  padding-top: 17px;
}
@media (min-width: 991px) {
  .title {
    padding-top: 20px;
    font-family: AppFontBold, sans-serif;
    font-size: 18px;
    margin-bottom: 40px;
  }
}

.subtitle-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  letter-spacing: 0.08em;
  text-wrap: balance;
  font-size: 12px;
  margin-bottom: 20px;
}
@media (min-width: 991px) {
  .subtitle-text {
    font-size: 20px;
    margin-bottom: 40px;
    display: none;
  }
}

.form-data {
  padding: 0 25px 25px;
  flex-grow: 1;
}
@media (min-width: 991px) {
  .form-data {
    zoom: 0.88;
  }
}
.form-data ion-label,
.form-data h3 {
  color: var(--color-black);
  font-family: AppFontMedium, sans-serif;
  font-weight: bold;
  font-size: 15px;
}

.input-time .input-time-section {
  border: 1px solid var(--color-black);
  border-radius: 26px;
  display: flex;
  align-items: center;
  padding: 15px;
  min-height: 47px;
}

.footer-block {
  width: 100%;
  padding: 15px;
  border-top: 1px solid var(--color-black);
}
.footer-block ion-button {
  width: 100%;
}
@media (min-width: 991px) {
  .footer-block ion-button {
    min-height: 38px;
  }
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
}

ion-item {
  --border-width: 1px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  --background: transparent;
  border: none;
  margin-top: 0;
  margin-bottom: 20px;
}
ion-item.no-line {
  --border-color: transparent;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

.name-col {
  padding: 0;
}
@media (min-width: 991px) {
  .name-col .stacked {
    left: 0;
  }
  .name-col ion-item {
    padding-inline: 0;
  }
  .name-col:first-child {
    padding-right: 7px;
  }
  .name-col:last-child {
    padding-left: 7px;
  }
}

.error_container {
  left: 20px;
}

.error_container.orderAt {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/delivery-details-modal/delivery-details-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EASC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AATD;ACHE;EDLF;IAEE,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;EAUA;AACF;AAGC;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAGE;EACC,kBAAA;EACD,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADF;AAEE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAAH;AAEE;EACC,mBAAA;AAAH;;AAKA;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAFD;ACtDE;ED+CF;IAWE,iBAAA;IACA,oCAAA;IACA,eAAA;IACA,mBAAA;EAAA;AACF;;AAGA;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAAD;AC1EE;EDiEF;IAYE,eAAA;IACA,mBAAA;IACA,aAAA;EACA;AACF;;AACA;EACC,oBAAA;EACA,YAAA;AAED;ACtFE;EDkFF;IAKE,UAAA;EAGA;AACF;AADC;;EAEC,yBAAA;EACA,sCAAA;EACA,iBAAA;EACA,eAAA;AAGF;;AACC;EACC,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAEF;;AACA;EACC,WAAA;EACA,aAAA;EACA,wCAAA;AAED;AADC;EACC,WAAA;AAGF;ACpHE;EDgHD;IAGK,gBAAA;EAKJ;AACF;;AADA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAID;;AADA;EACC,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAID;AAFC;EACC,2BAAA;AAIF;;AAAA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAGD;AChJE;EDwIF;IAQE,4BAAA;IACA,eAAA;EAIA;AACF;;AADA;EACC,UAAA;AAID;AChKE;ED8JA;IACC,OAAA;EAKD;EAHA;IACC,iBAAA;EAKD;EAFA;IACC,kBAAA;EAID;EAFA;IACC,iBAAA;EAID;AACF;;AAAA;EACC,UAAA;AAGD;;AAAA;EACC,gBAAA;AAGD","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper-modal {\n\t@include mobile {\n\t\tmargin-top: 25px;\n\t\tborder-bottom: none;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-bottom-right-radius: 0px;\n\t}\n\n\n\tborder-radius: 26px;\n\theight: 100%;\n\tposition: relative;\n\toverflow: auto;\n\toverflow-x: hidden;\n\tbackground: #f6f1ef;\n\ttext-transform: uppercase;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t.header-block {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t.close-icon {\n\t\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t\t}\n\t}\n}\n.title {\n\twidth: 100%;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n\tfont-family: AppFontMedium, sans-serif;\n\tfont-size: 15px;\n\tletter-spacing: 0.08em;\n\tmargin-bottom: 10px;\n\tpadding-top: 17px;\n\t@include desktop {\n\t\tpadding-top: 20px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 18px;\n\t\tmargin-bottom: 40px;\n\n\t}\n}\n.subtitle-text {\n\twidth: 100%;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n\tfont-family: AppFont, sans-serif;\n\tletter-spacing: 0.08em;\n\ttext-wrap: balance;\n\tfont-size: 12px;\n\tmargin-bottom: 20px;\n\n\t@include desktop {\n\t\tfont-size: 20px;\n\t\tmargin-bottom: 40px;\n\t\tdisplay: none;\n\t}\n}\n.form-data {\n\tpadding: 0 25px 25px;\n\tflex-grow: 1;\n\n\t@include desktop {\n\t\tzoom: 0.88;\n\t}\n\n\tion-label,\n\th3 {\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-weight: bold;\n\t\tfont-size: 15px;\n\t}\n}\n.input-time {\n\t.input-time-section {\n\t\tborder: 1px solid var(--color-black);\n\t\tborder-radius: 26px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 15px;\n\t\tmin-height: 47px;\n\t}\n}\n.footer-block {\n\twidth: 100%;\n\tpadding: 15px;\n\tborder-top: 1px solid var(--color-black);\n\tion-button {\n\t\twidth: 100%;\n    @include desktop {\n      min-height: 38px;\n    }\n\t}\n}\n\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n}\n\nion-item {\n\t--border-width: 1px !important;\n\t--border-radius: 52px !important;\n\t--border-color: #272727;\n\t--border-bottom: none;\n\t--background: transparent;\n\tborder: none;\n\tmargin-top: 0;\n\tmargin-bottom: 20px;\n\n\t&.no-line {\n\t\t--border-color: transparent;\n\t}\n}\n\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n\tletter-spacing: 0.08em;\n\n\t@include mobile {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 14px;\n\t}\n}\n\n.name-col {\n\tpadding: 0;\n\t@include desktop {\n\t\t.stacked {\n\t\t\tleft: 0;\n\t\t}\n\t\tion-item {\n\t\t\tpadding-inline: 0;\n\t\t}\n\n\t\t&:first-child {\n\t\t\tpadding-right: 7px;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-left: 7px;\n\t\t}\n\t}\n}\n\n.error_container  {\n\tleft: 20px;\n}\n\n.error_container.orderAt {\n\tmargin-top: 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
